import React from 'react'
import { Card, Container, Row, Col, Button } from 'react-bootstrap'
import './styles/cards.css'

export default function WarehouseManagement() {
    const CardsData = [
        {
            title: 'Movimientos',
            path: 'wms/movements',
            img: '/img/icon-movimientos.svg',
            button: 'card-text',
            class: '',
            colclass: 'justify-content-lg-center justify-content-xl-end justify-content-md-center justify-content-sm-center'
        },
        {
            title: 'Procesamiento',
            path: 'wms/processing',
            img: '/img/icon-procesamiento.svg',
            button: 'card-text',
            class: '',
            colclass: 'justify-content-lg-center justify-content-xl-start justify-content-md-center justify-content-sm-center'
        }
    ]
    return (
        <Container fluid className='vh-100 g-0 w-75'>
            <Row className="h-100 align-items-center justify-content-center g-0">
                {CardsData.map((item, index) =>{
                    return (
                        <Col key={index} className={item.colclass}>
                            <Card className="card-style mx-auto" >
                                <Card.Body className='card-body-custom'>
                                    <Card.Text className="text-center">{item.title}</Card.Text>
                                    <Card.Img variant="top" src={item.img}/>
                                </Card.Body>
                                <Card.Footer>
                                    <Button size="lg" variant={`align-middle ${item.class}`} href={item.path}>
                                        Continuar
                                    </Button>
                                </Card.Footer>
                            </Card>
                        </Col>
                    )
                })}
            </Row>
        </Container>
    )
}
